// src/components/AddPageButton.tsx

import React from 'react'
import { Plus } from 'lucide-react'
import clsx from 'clsx'

type AddPageButtonProps = {
  onClick: () => void
  className?: string
  disabled?: boolean
  children?: React.ReactNode
  'aria-label'?: string
}

export const AddPageButton: React.FC<AddPageButtonProps> = ({
  onClick,
  className = '',
  disabled = false,
  children,
  'aria-label': ariaLabel = 'Ajouter une page',
}) => {
  return (
    <button
      type="button"
      className={clsx(
        'inline-flex items-center gap-2 rounded-lg bg-brixel px-4 py-2 text-base font-semibold text-white shadow-md transition',
        'hover:bg-brixel/90 focus:outline-none focus:ring-2 focus:ring-brixel focus:ring-offset-2',
        disabled && 'opacity-60 cursor-not-allowed',
        className,
      )}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      <Plus className="w-5 h-5" aria-hidden="true" />
      {children ?? 'Ajouter une page'}
    </button>
  )
}

export default AddPageButton